<template>
  <div class="statistic-report-page">
    <a-row :gutter="20" style="margin-bottom: 20px">
      <a-col :span="24">
        <a-card>
          <div slot="title">
            <span>发送量趋势</span>
            <a-radio-group v-model="trendRange" size="small" style="float: right" @change="onTrendRangeChange">
              <a-radio-button value="7">近7天</a-radio-button>
              <a-radio-button value="30">近30天</a-radio-button>
            </a-radio-group>
          </div>
          <div id="trendChart" style="height: 300px; width: 100%" />
        </a-card>
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <a-col :span="12">
        <a-card>
          <div slot="title">通道成功率</div>
          <div id="successRateChart" style="height: 300px; width: 100%" />
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card>
          <div slot="title">发送量统计</div>
          <vxe-table :border="true" :data="statisticData" :loading="loading" height="300">
            <vxe-column field="gateway" title="网关类型" />
            <vxe-column field="success" title="成功数" />
            <vxe-column field="failure" title="失败数" />
            <vxe-column field="total" title="总数" />
            <vxe-column field="rate" title="成功率">
              <template #default="{ row }">
                <a-progress :percent="row.rate" :status="row.rate >= 90 ? 'success' : row.rate >= 70 ? 'normal' : 'exception'" />
              </template>
            </vxe-column>
          </vxe-table>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getNoticeHistoryStatistic } from '@/api/monitor'
import moment from 'moment'

export default {
  data() {
    return {
      trendRange: '7',
      trendChart: null,
      successRateChart: null,
      statisticData: [],
      loading: false
    }
  },
  mounted() {
    this.initCharts()
    this.fetchData()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    this.destroyCharts()
  },
  methods: {
    initCharts() {
      this.trendChart = echarts.init(document.getElementById('trendChart'))
      this.successRateChart = echarts.init(document.getElementById('successRateChart'))
    },
    destroyCharts() {
      if (this.trendChart) {
        this.trendChart.dispose()
      }
      if (this.successRateChart) {
        this.successRateChart.dispose()
      }
    },
    handleResize() {
      if (this.trendChart) {
        this.trendChart.resize()
      }
      if (this.successRateChart) {
        this.successRateChart.resize()
      }
    },
    onTrendRangeChange() {
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      const now = moment()
      const params = {
        end_time: now.format('YYYY-MM-DD HH:mm:ss'),
        start_time: now.clone().subtract(Number(this.trendRange), 'day').format('YYYY-MM-DD HH:mm:ss')
      }
      getNoticeHistoryStatistic(params)
        .then(res => {
          this.loading = false
          if (res.code === 0 && res.data.list) {
            this.renderStatisticTable(res.data.list)
            this.renderSuccessRateChart(res.data.list)
            // 模拟趋势数据（按天聚合）
            this.renderTrendChart(res.data.list)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    renderStatisticTable(list) {
      this.statisticData = list.map(item => {
        const total = item.success + item.failure
        return {
          gateway: item.gateway,
          success: item.success,
          failure: item.failure,
          total: total,
          rate: total > 0 ? Math.round((item.success / total) * 100) : 0
        }
      })
    },
    renderSuccessRateChart(list) {
      const data = list.map(item => {
        const total = item.success + item.failure
        return {
          name: item.gateway,
          value: total > 0 ? Math.round((item.success / total) * 100) : 0
        }
      })
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}%'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '成功率',
            type: 'pie',
            radius: '60%',
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.successRateChart.setOption(option)
    },
    renderTrendChart(list) {
      // 使用网关类型作为维度展示柱状图
      const xData = list.map(item => item.gateway)
      const successData = list.map(item => item.success)
      const failureData = list.map(item => item.failure)
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['成功', '失败']
        },
        xAxis: {
          type: 'category',
          data: xData
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '成功',
            type: 'bar',
            stack: 'total',
            data: successData,
            itemStyle: { color: '#67C23A' }
          },
          {
            name: '失败',
            type: 'bar',
            stack: 'total',
            data: failureData,
            itemStyle: { color: '#F56C6C' }
          }
        ]
      }
      this.trendChart.setOption(option, true)
    }
  }
}
</script>

<style scoped>
.statistic-report-page {
  padding: 10px;
}
</style>
